export default __webpack_public_path__ + "static/media/turkey3.0a4f6fdd.png";